import { DisplayCardContainer } from '@aon/aon-tws-common-ui';
import React from 'react';
import { AdminHelper, SurveyAdminCardType } from '../../../../utilities/AdminHelper';

export const SurveyAdminMenu = (props: { surveyId: number; handleCancelSurveyClick: () => void }) => {
	return <DisplayCardContainer>{getAdminCards()}</DisplayCardContainer>;

	function getAdminCards() {
		const adminCards = [
			SurveyAdminCardType.PreviewSurvey,
			SurveyAdminCardType.SurveyOverview,
			SurveyAdminCardType.AddRemoveBenchmarks,
			SurveyAdminCardType.ReportingUsers,
			SurveyAdminCardType.TrendTo,
			SurveyAdminCardType.CancelSurvey,
			SurveyAdminCardType.AnonymityThreshold,
			SurveyAdminCardType.ReportingProfiles,
			SurveyAdminCardType.ManageDimensions,
			SurveyAdminCardType.ReopenSurvey,
		];

		return AdminHelper.SurveyAdminCards({
			surveyId: props.surveyId,
			cards: adminCards,
			handleCancelSurveyClick: props.handleCancelSurveyClick,
		});
	}
};
